// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-5ddf7292] {\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #727272;\n}\n.info[data-v-5ddf7292] {\n  font-weight: normal;\n  color: #11291B;\n}\n.separation-of-funds__separator[data-v-5ddf7292] .separator-custom {\n  --background-color-active: #b5c3bc;\n  --line-separator-color: #b5c3bc;\n  font-size: 0.875rem;\n}", ""]);
// Exports
module.exports = exports;
